import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type NavigationInfo = {
  name: string;
  href?: string;
  isCategory?: boolean;
  isRetailer?: boolean;
  isProduct?: boolean;
  isSearchable?:boolean;
};

type NavigationState = {
  navigation: NavigationInfo[];
  hasNavigation?: boolean;
  isNavigationLoading: boolean;
};

type NavigationAction = {
  updateNavigation: (info: NavigationInfo[]) => void;
  /**Add to the current navigation */
  addNavigation: (info: NavigationInfo[]) => void;
  updateHasNavigation: () => void;
};

const defaultState: NavigationState = {
  navigation: [],
  hasNavigation: false,
  isNavigationLoading: true,
};

export const useNavigationStore = create<NavigationState & NavigationAction>()(
  persist(
    devtools(
      immer((set, get) => ({
        ...defaultState,
        updateNavigation(info) {
          set((state) => {
            state.navigation = info;
            state.isNavigationLoading = false;
          });
          get().updateHasNavigation();
        },
        addNavigation(info) {
          set((state) => {
            const newNavs = info.filter((i) =>
              state.navigation.some((n) => n.name.toLowerCase() !== i.name.toLowerCase()),
            );
            state.navigation = [...state.navigation, ...newNavs];
            state.isNavigationLoading = false;
          });
          get().updateHasNavigation();
        },
        updateHasNavigation() {
          set((state) => {
            state.hasNavigation = state.navigation.length > 0;
          });
        },
      })),
      {
        name: 'Navigation Store',
        enabled: true,
      },
    ),
    {
      name: 'navigation-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ navigation: state.navigation }),
    },
  ),
);
